import { render } from "./salesreport.vue?vue&type=template&id=4daa69fb&scoped=true"
import script from "./salesreport.vue?vue&type=script&lang=js"
export * from "./salesreport.vue?vue&type=script&lang=js"

import "./salesreport.vue?vue&type=style&index=0&id=4daa69fb&scoped=true&lang=css"

import exportComponent from "C:\\actions-runner\\_work\\cims-billing.ui\\cims-billing.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4daa69fb"]])

export default __exports__